import { Link } from 'react-router-dom';
import { useBlockMedia } from './useBlockMedia';
import { MediaImage, Reveal } from '../components/ui';

interface SplitFeatureData {
  eyebrow?: string;
  heading?: string;
  body?: string;
  linkLabel?: string;
  linkHref?: string;
  mediaId?: string;
  mediaSide?: 'left' | 'right';
}

/** Edge-to-edge image beside a copy column — the "Our Story" teaser in the design. */
export function SplitFeatureBlock({ data }: { data: SplitFeatureData }) {
  const media = useBlockMedia(data.mediaId);
  const mediaFirst = (data.mediaSide ?? 'left') === 'left';

  const mediaNode = (
    <MediaImage
      media={media}
      alt={data.heading ?? ''}
      className="sz-split__media"
      placeholder="Bar craft / interior detail"
      zoomOnHover
      sizes="(max-width: 900px) 100vw, 50vw"
    />
  );

  const copyNode = (
    <Reveal className="sz-split__copy">
      {data.eyebrow && <p className="sz-eyebrow sz-eyebrow--display">{data.eyebrow}</p>}
      {data.heading && <h2 className="sz-split__heading">{data.heading}</h2>}
      {data.body && <p className="sz-split__body">{data.body}</p>}
      {data.linkHref && data.linkLabel && (
        <Link to={data.linkHref} className="sz-link-caps">
          {data.linkLabel}
        </Link>
      )}
    </Reveal>
  );

  return (
    <section className="sz-split">
      {mediaFirst ? mediaNode : copyNode}
      {mediaFirst ? copyNode : mediaNode}
    </section>
  );
}
